
import React, { useEffect, useRef, useState } from 'react';
import { Modal, Box, Dialog, DialogTitle, DialogContent, Grid, RadioGroup, FormControlLabel, Radio, useTheme, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import filterIcon from './../assets/Filtericon.png';
import starPic from './../assets/StarWhite.svg';
import locationIcon from './../assets/locationImg.svg';
import foodPlaceHolder from './../assets/food-img-placeholder.jpg';
import greenDot from './../assets/greendot.svg';
import redDot from './../assets/reddot.svg';
import cartArrow from './../assets/vectorGreater.png';
import Loader from './Loader/Loader';
import { useTranslation } from 'react-i18next';
import authMiddleware from './authMiddleware';
import { ActionTypes } from '../Redux/Contants/action-types';
import { useDispatch } from 'react-redux';
import '../Styles/Reels/OrderPopup.css';
import { useCart } from '../CartProvider';
import ConfirmationModal from './ConfirmationModal';
import { toast } from 'react-toastify';
import axiosUserInstance from '../axiosUserInstance';
import axiosVendorInstance from '../axiosVendorInstance';
import CloseIcon from '../assets/svg/closeIcon';
import { IoPlayOutline } from 'react-icons/io5';
import FoodDetailsModal from '../Views/User/Search/FoodMenuDetailsModal';

const OrderPopop = ({
    vendorID,
    selectedOffer,
    restaurantName,
    handleClose,
    rating,
    vendorAddress,
    vendorDistance,
    user_Rating_count
}) => {
    const isDesktop = useMediaQuery('(min-width:601px)'); 
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [open, setOpen] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState('Relevance');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [filteredItems, setFilteredItems] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [cartCount, setCartCount] = useState(0);

    const [isLoading, setIsLoading] = useState(false);
    const [animateModal, setAnimateModal] = useState(false);
    const [closing, setClosing] = useState(false);
    const [openOrderPopup, setOpenOrderPopup] = useState(false);
    const handleOpenOrderPopup = () => setOpenOrderPopup(true);

    const [selectedMenuName, setSelectedMenuName] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [modalResolve, setModalResolve] = useState(null);
    const [data, setData] = useState([]);

    const { fetchCartCount, setOfferModelPercentage } = useCart();
    const scrollRef = useRef(null);
    const videoRefs = useRef({});
    const [playingIndex, setPlayingIndex] = useState(null);

    const [selectedFood, setSelectedFood] = useState(null);
    const [openDetailPopup, setOpenDetailPopup] = useState(false);
    const [loadingItemId, setLoadingItemId] = useState(false);

    const handlePlay = (e, index) => {
        e.stopPropagation();
    
        Object.entries(videoRefs.current).forEach(([key, video]) => {
            if (parseInt(key) !== index && video && !video.paused) {
                video.pause();
            }
        });
    
        const currentVideo = videoRefs.current[index];
        if (currentVideo) {
            currentVideo.play();
            setPlayingIndex(index);
        }
    };

    const handleMenuClick = (menuName) => {
        setSelectedMenuName(prev => 
            prev.includes(menuName) 
                ? prev.filter(name => name !== menuName)
                : [...prev, menuName] 
        );
    };

    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (!scrollContainer) return;
    
        const handleWheelScroll = (event) => {
            if (event.deltaY !== 0) {
                event.preventDefault();
                scrollContainer.scrollLeft += event.deltaY * 2;
            }
        };
    
        scrollContainer.style.overflowX = 'scroll';
        scrollContainer.addEventListener('wheel', handleWheelScroll, { passive: false });
    
        return () => {
            scrollContainer.removeEventListener('wheel', handleWheelScroll);
        };
    }, []);
    
    const displayedItems = filteredItems
        .filter(item => 
            selectedMenuName.length === 0 || 
        selectedMenuName.some(name => item.menuName?.toLowerCase() === name.toLowerCase())
        )
        .filter(item => {
            if (selectedFilter === 'Pure Veg') return item.vegetarian === true;
            if (selectedFilter === 'Non-Veg') return item.vegetarian === false;
            return true; 
        })
        .sort((a, b) => {
            if (selectedFilter === 'priceLowToHigh') return a.menuItemPrice - b.menuItemPrice;
            if (selectedFilter === 'priceHighToLow') return b.menuItemPrice - a.menuItemPrice;
            return 0;
        });

    useEffect(() => {
        const totalCount = Object.values(quantities).reduce((sum, qty) => sum + qty, 0);
        setCartCount(totalCount);
    }, [quantities]);

    const increaseQuantity = async (itemID, restaurantID) => {
        const newQuantity = (quantities[itemID] || 0) + 1;
        setQuantities((prevQuantities) => ({
            ...prevQuantities,
            [itemID]: newQuantity,
        }));

        await updateCartAPI(itemID, restaurantID, newQuantity);
    };

    const decreaseQuantity = async (itemID, restaurantID) => {
        const newQuantity = Math.max(0, (quantities[itemID] || 0) - 1);
        setQuantities((prevQuantities) => ({
            ...prevQuantities,
            [itemID]: newQuantity,
        }));

        await updateCartAPI(itemID, restaurantID, newQuantity);
    };

    const updateCartAPI = async (itemID, restaurantID, quantity) => {
        try {
            if (quantity === 0) {
                await axiosUserInstance.delete(`/cartdetails/customer/vendor/${restaurantID}/${itemID}`);
            } else {
                await axiosUserInstance.put(
                    `/cartdetails/customer/vendor/${restaurantID}/item/${itemID}`,
                    { Quantity: quantity },
                );
            }

            await fetchDataFromCart(); 
            await fetchCartCount();
        } catch (error) {
            toast.error('Failed to update cart');
        }
    };

    const fetchFoodDetails = async (itemId) => {
        try {
            const response = await axiosVendorInstance.get(`/vendors/menuitems/particularitem/${itemId}`);
            return response?.data?.menuItem;
            
        } catch (error) {
            toast.error('Failed to load food details');
            console.error('Error fetching food details:', error);
            return null;
        }
    };
    
    const handleMoreInfo = async (item, isVideoPlaying = false) => {
        const foodDetails = await fetchFoodDetails(item.menuItemId);
        if (foodDetails) {
            setSelectedFood({
                ...foodDetails,
                autoplay: isVideoPlaying
            });
            setOpenDetailPopup(true);
        }
    };
    
    
    const handleCloseDetailPopup = () => {
        setOpenDetailPopup(false);
        setSelectedFood(null);
    };

    
    useEffect(() => {
        if (!vendorID || !authMiddleware()) return;
    
        const fetchMenuItems = async () => {
            setIsLoading(true);
            let allMenuItems = [];
            let pageNo = 1;
            const pageSize = 100;
            let hasMoreData = true;

            try {
                while (hasMoreData) {
                    const response = await axiosVendorInstance.get(`/vendors/menuitems/${vendorID}`, {
                        params: {
                            page_no: pageNo,
                            page_size: pageSize,
                        }, 
                        skipAuth: true
                    });
    
                    const items = response?.data?.menuItems || [];

                    const menuItems = items.map((item) => ({
                        menuItemId: item?.ID,
                        vendorDesc: item?.Vendor_Info?.Vendor_Description || 'N/A',
                        vendorRating: item?.vendor_menu?.Rating || 'N/A',
                        vendorReview: item?.vendor_menu?.Review || 'N/A',
                        foodImage: item?.Avatar_key,
                        vegetarian: item?.Vegetarian,
                        menuItemName: item?.Item_name,
                        menuItemDescription: item?.Description,
                        menuItemPrice: item?.Price,
                        menuName: item?.vendor_menu?.Menu_name,
                        menuIngridents : item?.Ingridents,
                    }));

                    allMenuItems = [...allMenuItems, ...menuItems];

                    if (items.length < pageSize) {
                        hasMoreData = false;
                    } else {
                        pageNo += 1;
                    }
                }
                setFilteredItems(allMenuItems);

            } catch (error) {
                console.error('Error fetching restaurant details:', error);
                setFilteredItems([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchMenuItems();
        setClosing(false);
        handleOpenOrderPopup();
    
        setTimeout(() => {
            setAnimateModal(true);
        }, 100);
    }, [restaurantName, vendorID]); 
    
    const handleFilterChange = (event) => {
        setSelectedFilter(event.target.value);
        handleFilterPopupClose(); 
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleFilterPopupClose = () => {
        setOpen(false);
    };

    const showConfirmationPopup = () => {
        return new Promise((resolve) => {
            setModalOpen(true);
            setModalResolve(() => resolve);
        });
    };

    const handleCloseModal = (confirmed) => {
        setModalOpen(false);
        if (modalResolve) modalResolve(confirmed);
        setModalResolve(null);
    };

    const handleConfirmModal = async () => {
        handleCloseModal(true);
    };

    const fetchDataFromCart = async () => {
        const location = JSON.parse(localStorage.getItem('selectedLocation'));

        const lat = location?.lat;
        const lng = location?.lng;
        try {
            const response = await axiosUserInstance.get('/cartdetails/cartsp', {
                params: {
                    latitude: lat,
                    longitude: lng,
                }
            });
            const data = response?.data?.cartDetails[0]?.Cart_Information;
            setData(data);

            const initialQuantities = {};
            data?.forEach((cartItem) => {
                initialQuantities[cartItem.Item_ID] = cartItem.Item_Quantity;
            });
            setQuantities(initialQuantities);
        } catch (error) {
            console.error('Error fetching cart data:', error);
        }
    };

    useEffect(() => {
        fetchDataFromCart();
    }, []);

    const addToCart = async (e,itemID, restaurantID) => {
        e.stopPropagation();
        try {
            setLoadingItemId(true);
            const differentRestaurantItem = data?.some(
                (cartItem) => cartItem.Vendor_Id !== restaurantID
            );
            
            if (differentRestaurantItem) {
                const confirmed = await showConfirmationPopup(
                    'Your cart contains items from another restaurant. Would you like to reset your cart for adding items from this restaurant?'
                );
    
                if (!confirmed) {
                    await fetchDataFromCart(); // Refresh cart data to ensure UI consistency
                    return;
                }
    
                await axiosUserInstance.delete('/cartdetails/customer/delteallByCustomerid');
            }
    
            const isItemInCart = data?.find(
                (cartItem) => cartItem.Item_ID === parseInt(itemID)
            );

            if (isItemInCart) {
                toast.info('Item is already in the cart');
                return;
            }
    
            const itemIdToSend = {
                Item_id: itemID,
                Quantity: 1,
            };
    
            await axiosUserInstance.post(
                `/cartdetails/customer/vendor/${restaurantID}/item/${itemID}`,
                itemIdToSend
            );
    
            await fetchDataFromCart();
            await fetchCartCount();
    
            dispatch({
                type: ActionTypes.SELECTED_VENDOR_ID,
                payload: restaurantID,
            });

            setQuantities((prevQuantities) => ({
                ...prevQuantities,
                [itemID]: 1,
            }));
        } catch (error) {
            toast.error('Failed to add item');
        } finally {
            setLoadingItemId(false);
        }
    };

    const handleNavigateToCart = () => {
        navigate('/cart');
        setOfferModelPercentage(selectedOffer);
    };

    return (
        <div>
            <>
                <Modal 
                    open={openOrderPopup}
                    style={{
                        backdropFilter: 'blur(10px)',
                        backgroundColor: '#2C3142B2 !important'
                    }} 
                    onClose={()=>{ 
                        setClosing(true);
                        handleClose();
                    }}>
                    <Box className={`style ${animateModal ? 'animate' : ''} ${closing ? 'close' : ''}`}>
                        {isLoading || loadingItemId && <Loader 
                            style={{borderRadius:'12px'}}
                        />}
                        <div className="restaurant-tittle-container">
                            <div className='restaurant-name-rating'>
                                <div className="restaurant-name-container">
                                    <h1 className="order-restaurant-name">{restaurantName}</h1>
                                    <CloseIcon
                                        onClick={handleClose}
                                        className='close-icon'
                                    />
                                </div>
                                <div className='res-rating-distance'>
                                    <div className="res-star-rating">
                                        <div className="img-rating-restaurant">
                                            <p className="rating-order">{Number(rating || 0).toFixed(1)}</p>
                                            <img className="star-img-order" style={{marginBottom:'4px'}} src={starPic} alt="star" />
                                        </div>
                                        <div className='customer-count-rating'>
                                            <p className="rating-count-restaurant1">{user_Rating_count}</p>
                                            <p className='rating-text1'>{t('restaurantpage.ratings-text')}</p>
                                        </div>
                                    </div>
                                    <div className="res-location-kms">
                                        <img src={locationIcon} alt="location" />
                                        <p className='res-distance1'>{vendorDistance?.toFixed(1) || 0} miles</p>
                                    </div>
                                </div>
                                {vendorAddress && (
                                    <div className="res-address1">
                                        <img src={locationIcon} alt="location" />
                                        <a 
                                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(vendorAddress)}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="res-address-link"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <p className='res-address-text'>{vendorAddress || ''}</p>
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div>
                            <div ref={scrollRef} className="order-filters-scroll">
                                <div className="filters">
                                    <p className='bg-css' onClick={handleOpen}>
                                        <img src={filterIcon} alt="filter-icon" className='filter-icon' />
                                        Filter
                                    </p>
                                    {[...new Set(filteredItems?.map(item => item?.menuName))]
                                        ?.sort((a, b) => b.localeCompare(a))
                                        ?.map((menuName, index) => (
                                            <p
                                                key={index}
                                                className={`bg-css ${selectedMenuName.includes(menuName) ? 'active-filter' : ''}`}
                                                onClick={() => handleMenuClick(menuName)}
                                            >
                                                {menuName}
                                            </p>
                                        ))}
                                </div>
                            </div>

                            <div className="scrollable-container" style={{ height: isDesktop ? (cartCount > 0 ? '330px' : '385px') : (cartCount > 0 ? '400px' : '470px') }}>
                                {displayedItems.length > 0 && (
                                    displayedItems.map((data, index) => {
                                        const shortDescription = data.menuItemDescription ? data.menuItemDescription.slice(0, 130) : 'No description available';
                                        const shouldShowMore = data.menuItemDescription && data.menuItemDescription.length > 120;
                                        return (
                                            <>
                                                <div 
                                                    key={data.menuItemId || index} 
                                                    className="item-container-order" 
                                                    onClick={() => handleMoreInfo(data, playingIndex === index)}
                                                >
                                                    <div className="food-media-order-wrapper">
                                                        {data?.foodImage?.match(/\.(mp4|webm|ogg)$/i) ? (
                                                            <div className="order-video-container1">
                                                                <video
                                                                    src={data?.foodImage}
                                                                    muted
                                                                    playsInline
                                                                    // eslint-disable-next-line react/no-unknown-property
                                                                    webkit-playsinline='true'
                                                                    preload="metadata"
                                                                    className="order-food-video"
                                                                    ref={(el) => videoRefs.current[index] = el}
                                                                    onClick={(e) => {
                                                                        const rect = e.currentTarget.getBoundingClientRect();
                                                                        const clickX = e.clientX - rect.left;
                                                                        const clickY = e.clientY - rect.top;
                                                                        const centerX = rect.width / 2;
                                                                        const centerY = rect.height / 2;
                                                                        const radius = Math.min(rect.width, rect.height) * 0.2;
                                                                    
                                                                        const distanceFromCenter = Math.hypot(clickX - centerX, clickY - centerY);
                                                                    
                                                                        if (distanceFromCenter < radius) {
                                                                            e.stopPropagation();
                                                                            const video = videoRefs.current[index];
                                                                            if (video) {
                                                                                if (video.paused) {
                                                                                    video.play();
                                                                                    setPlayingIndex(index);
                                                                                } else {
                                                                                    video.pause();
                                                                                    setPlayingIndex(null);
                                                                                }
                                                                            }
                                                                        } else {
                                                                            handleMoreInfo(data, playingIndex === index);
                                                                        }
                                                                    }}
                                                                    onEnded={() => setPlayingIndex(null)}
                                                                    onError={(e) => {
                                                                        e.target.poster = foodPlaceHolder;
                                                                    }}
                                                                />
                                                                {playingIndex !== index && (
                                                                    <button onClick={(e) => handlePlay(e, index)} className='play-btn'>
                                                                        <IoPlayOutline color='white' fontSize={34} />
                                                                    </button>
                                                                )}

                                                            </div>
                                                        ) : (
                                                            <img
                                                                className='Food-order-image'
                                                                src={data?.foodImage || foodPlaceHolder}
                                                                alt='Food img'
                                                                onError={(e) => {
                                                                    e.target.src = foodPlaceHolder;
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className="item-details-order">
                                                        <div className="item-row1">
                                                            <div className="reddot-iten-name" style={{cursor: 'pointer'}}>
                                                                {data.vegetarian !== null &&(
                                                                    <img className="item-reddot-order" src={data.vegetarian === true ? greenDot : data.vegetarian === false ? redDot : ''} alt="dot" />
                                                                )}
                                                                <h5 className="items-name-order">{data.menuItemName}</h5>
                                                            </div>
                                                            <p className="item-cost-order">$ {parseFloat(data.menuItemPrice)?.toFixed(2)}</p>
                                                        </div>
                                                        <div className="order-item-row2">
                                                            <p className="item-desc-order" style={{width: '100%', cursor: 'pointer'}}>
                                                                <span dangerouslySetInnerHTML={{ __html: shortDescription }} style={{display:'inline'}}></span>
                                                                {shouldShowMore && (
                                                                    <button className="more-btn">More</button>
                                                                )}
                                                            </p>
                                                        </div>
                                                        <div className="desc-add-item">
                                                            <p></p>
                                                            {quantities[data.menuItemId] > 0 ? (
                                                                <>
                                                                    <div className="quantity-controls" onClick={(e) =>e.stopPropagation()}>
                                                                        <span onClick={() => decreaseQuantity(data.menuItemId, vendorID)}>-</span>
                                                                        <div className="quantity-number">{quantities[data.menuItemId]}</div>
                                                                        <span onClick={() => increaseQuantity(data.menuItemId, vendorID)}>+</span>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <button className="item-add-btn" onClick={(e) => addToCart(e,data.menuItemId, vendorID)}>
                                                                    {t('reelsright.add-button')}
                                                                </button>
                                                            )}
                                                           
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='border'></div>
                                            </>
                                        );
                                    })
                                )}
                                {!isLoading && displayedItems.length === 0 && (
                                    <p className='no-item-found'>{t('reelsright.no-item-found')}</p>
                                )}
                            </div>
                        </div>
                        {cartCount > 0 && (
                            <div className="red-box-review-cart">
                                <h5 className='red-box-count'>{cartCount} {t('reelsright.item-added-title')}</h5>
                                <div className="review-cart-link" 
                                    onClick={() =>handleNavigateToCart()}>
                                    {t('reelsright.review-cart-title')}
                                    <img src={cartArrow} alt="arrow" className='cart-arrow' />
                                </div>
                            </div>
                        )}
                        {selectedFood && (
                            <FoodDetailsModal
                                open={openDetailPopup}
                                handleClose={handleCloseDetailPopup}
                                food={selectedFood}
                                orderBtn={false}
                            />
                        )}

                    </Box>
                </Modal>

                {!isDesktop && (
                    <Modal open={open} onClose={handleClose} >
                        <Box className={`style1 ${animateModal ? 'animate' : ''}`}>
                            <h2 className='filter-title'>{t('homescreen.filter-title')}</h2>
                            <Grid container spacing={2} className="width-of-dialog-box">
                                <Grid item xs={isMobile ? 6 : 7}>
                                    <div className="css-mhc70k-MuiGrid-root MuiGrid-item">
                                        <RadioGroup value={selectedFilter} onChange={handleFilterChange}>
                                            <FormControlLabel onClick={() => setSelectedMenuName(null)}
                                                value="Relevance"
                                                control={<Radio />}
                                                label={t('homescreen.sort-by-tab-val1')} />
                                            <FormControlLabel
                                                value="priceLowToHigh"
                                                control={<Radio />}
                                                label={t('homescreen.sort-by-tab-val4')} />
                                            <FormControlLabel
                                                value="priceHighToLow"
                                                control={<Radio />}
                                                label={t('homescreen.sort-by-tab-val5')} />
                                            <FormControlLabel
                                                value="Pure Veg"
                                                control={<Radio />}
                                                label={t('homescreen.veg')} />
                                            <FormControlLabel
                                                value="Non-Veg"
                                                control={<Radio />}
                                                label={t('homescreen.nonveg')} />
                                            <FormControlLabel
                                                value="Veg and Non-Veg"
                                                control={<Radio />}
                                                label={t('homescreen.veg-or-nonveg-tab-val3')} />
                                        </RadioGroup>
                                    </div>
                                </Grid>
                            </Grid>
                        </Box>
                    </Modal>
                )}

                {isDesktop && (
                    <Dialog open={open} onClose={handleClose} width="70%" height="300px" >
                        <DialogTitle className="filters-title">
                            {t('homescreen.filter-title')}
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2} className="width-of-dialog-box">
                                <Grid item xs={isMobile ? 6 : 7}>
                                    <div className="css-mhc70k-MuiGrid-root MuiGrid-item">
                                        <RadioGroup value={selectedFilter} onChange={handleFilterChange}>
                                            <FormControlLabel onClick={() => setSelectedMenuName(null)}
                                                value="Relevance"
                                                control={<Radio />}
                                                label={t('homescreen.sort-by-tab-val1')} />
                                            <FormControlLabel
                                                value="priceLowToHigh"
                                                control={<Radio />}
                                                label={t('homescreen.sort-by-tab-val4')} />
                                            <FormControlLabel
                                                value="priceHighToLow"
                                                control={<Radio />}
                                                label={t('homescreen.sort-by-tab-val5')} />
                                            <FormControlLabel
                                                value="Pure Veg"
                                                control={<Radio />}
                                                label={t('homescreen.veg')} />
                                            <FormControlLabel
                                                value="Non-Veg"
                                                control={<Radio />}
                                                label={t('homescreen.nonveg')} />
                                            <FormControlLabel
                                                value="Veg and Non-Veg"
                                                control={<Radio />}
                                                label={t('homescreen.veg-or-nonveg-tab-val3')} />
                                        </RadioGroup>
                                    </div>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Dialog>
                )}
            </>

            <ConfirmationModal
                open={isModalOpen}
                onClose={handleCloseModal}
                onConfirm={handleConfirmModal}
                message="Your cart contains items from another restaurant. Would you like to reset your cart to add items from this restaurant?"
            />
        </div>
    );
};

export default OrderPopop;